<template>
    <section class="page-dashbord-category mt-5">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <contact-form :inputs="formCategory" :title="'دسته بندی جدید'" class="mb-4" :action="true" @submitAction="addNewCat" />
                </div>
            </div>
            <div class="row no-gutters">
                <div class="col-12 px-3">
                    <div class="shadow shadow-sm  mb-5 bg-white">
                        <b-table stacked="lg" :fields="fieldsItems" :items="listCategory" class="text-center">
                            <template v-slot:cell(category)="data" >
                                <p class="m-0" v-if="!data.item.isEdit">{{data.item.category}}</p>
                                <div class="group-form mb-0">
                                    <input type="text" :class="{active:data.item.category != ''}" v-model="data.item.category" v-if="data.item.isEdit">
                                    <span class="bar"></span>
                                </div>
                            </template>
                            <template v-slot:cell(en_category)="data" >
                                <p class="m-0" v-if="!data.item.isEdit">{{data.item.en_category}}</p>
                                <div class="group-form mb-0" v-if="data.item.isEdit">
                                    <input type="text" :class="{active:data.item.en_category != ''}" v-model="data.item.en_category" v-if="data.item.isEdit">
                                    <span class="bar"></span>
                                </div>

                            </template>
                            <template v-slot:cell(action)="data" >
                                <div class="d-flex flex justify-content-around  align-items-center">
                                      <div class="input-checkbox rtl text-right d-inline-block" v-if="data.item.isEdit">
                                          <div class="md-checkbox">
                                              <input type="checkbox" :id="'pub'+data.index" v-model="data.item.pub">
                                              <label :for="'pub'+data.index" class="font-14">منتشر کردن</label>
                                          </div>
                                      </div>
                                      <span data-balloon-pos="up" data-balloon="حذف" v-if="!data.item.isEdit">
                                        <button
                                          class="bttn-material-circle bttn-jelly bttn-md bttn-danger text-center"
                                          v-ripple
                                          @click.stop="remove(data.item, data.index)"
                                        >
                                          <i class="flaticon-dustbin"></i>
                                        </button>
                                      </span>
                                      <span data-balloon-pos="up" data-balloon="ویرایش" v-if="!data.item.isEdit">
                                        <button
                                          class="bttn-material-circle bttn-jelly bttn-md bttn-primary text-center"
                                          v-ripple
                                          @click.stop="edit(data.item, data.index)"
                                        >
                                          <i class="flaticon-content"></i>
                                        </button>
                                      </span>
                                      <span data-balloon-pos="up" data-balloon="دخیره" v-if="data.item.isEdit">
                                        <button
                                          class="bttn-material-circle bttn-jelly bttn-md bttn-success text-center"
                                          v-ripple
                                          @click.stop="save(data.item, data.index)"
                                        >
                                          <i class="flaticon-cogwheel"></i>
                                        </button>
                                      </span>
                                </div>
                            </template>
                        </b-table>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import contactForm from 'cp/contact-form.vue'

export default {
  name: 'page-dashbord-category',
  components: {
    contactForm
  },
  data () {
    return {
      fieldsItems: [
        { key: 'category', label: 'نام دسته بندی به فارسی' },
        { key: 'en_category', label: 'نام دسته بندی به انگلیسی' },
        { key: 'action', label: 'عملیات' }]
    }
  },
  mounted () {
    this.$store.dispatch('dashboardCategory/getAllCategory')
  },
  computed: {
    formCategory () {
      return this.$store.state.dashboardCategory.formCategory
    },
    listCategory () {
      return this.$store.state.dashboardCategory.listCategory
    }
  },
  methods: {
    remove (item, index) {
      this.$store.dispatch('dashboardCategory/deleteCat', { id: item.id, index })
    },
    edit (item, index) {
      this.$set(this.listCategory[index], 'isEdit', !this.listCategory[index].isEdit)
    },
    save (item, index) {
      this.$set(this.listCategory[index], 'isEdit', !this.listCategory[index].isEdit)
      let FilterItem = Object.assign({}, item)
      delete FilterItem.en_subcategory
      delete FilterItem.subcategory
      delete FilterItem.subcategory_id
      delete FilterItem.isEdit
      this.$store.dispatch('dashboardCategory/updateCat', FilterItem)
    },
    addNewCat () {
      let formCategory = this.formHandeler(this.formCategory)
      this.$store.dispatch('dashboardCategory/addNewCat', formCategory)
    }
  }

}
</script>
<style lang="less">
@import (reference) "../../assets/css/variable.less";
.page-dashbord-category {
  .box-clear;
}
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/category.vue